import {
  Invalidate,
  SuggestionsError,
  SuggestionsLoaded,
} from 'common/actions/asanaTaskSuggestions';

type AsanaAction = Action & {
  search: string;
};

export default function asanaTaskSuggestions(state = {}, action: AsanaAction) {
  switch (action.type) {
    case SuggestionsLoaded: {
      return Object.assign({}, state, {
        [action.search]: {
          error: null,
          lastUpdated: action.timestamp,
          loading: false,
          items: action.suggestions,
        },
      });
    }

    case SuggestionsError: {
      return Object.assign({}, state, {
        [action.search]: {
          error: action.error,
          lastUpdated: action.timestamp,
          loading: false,
          items: null,
        },
      });
    }

    case Invalidate: {
      return {};
    }

    default:
      return state;
  }
}
